/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantGroupResult } from '../../models/item-variant-group-result';

export interface ItemVariantGroupsGet$Params {
  'Active-Tenant-Identifier': string;
}

export function itemVariantGroupsGet(http: HttpClient, rootUrl: string, params: ItemVariantGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantGroupResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'itemVariants'?: Array<ItemVariantGroupResult>;
      };
      }>;
    })
  );
}

itemVariantGroupsGet.PATH = '/item-variant-groups';
